import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useOptions } from '../../contexts/OptionsContext';
import { updateStudent } from '../../api/services/studentsService';

function EditStudentModal({ isOpen, student, onClose, onSave }) {
  const { years, semesters } = useOptions();
  const [formData, setFormData] = useState({ student_name: '', student_id: '', email: '', department: '', year: '', semester: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (student) setFormData({ id: student.id, student_name: student.student_name || student.name || '', student_id: student.student_id || student.id || '', email: student.email || '', department: student.department || student.branch || '', year: student.year || '', semester: student.semester || '' });
  }, [student, isOpen]);

  const handleInputChange = (e) => { const { name, value } = e.target; setFormData(p => ({ ...p, [name]: value })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try { const r = await updateStudent(formData.id || formData.student_id, formData); if (r.success) await onSave({ ...formData, ...r.data }); }
    catch (e) { console.error(e); } finally { setIsSubmitting(false); }
  };

  if (!isOpen) return null;

  const inputCls = "w-full px-4 py-2 border border-purple-glow-20 rounded-lg outline-none";

  return (
    <>
      <div className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm" onClick={onClose} />
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <div className="bg-screen-bg rounded-lg w-full max-w-md border border-purple-glow-30 shadow-glow-lg" onClick={(e) => e.stopPropagation()}>
          <div className="flex items-center justify-between p-6 border-b border-purple-glow-15">
            <h2 className="text-2xl font-bold text-text-main">Edit Student</h2>
            <button onClick={onClose} className="p-2 hover:bg-purple-glow-10 rounded-lg transition-colors cursor-pointer"><X size={20} className="text-text-sub" /></button>
          </div>
          <form onSubmit={handleSubmit} className="p-6">
            <div className="space-y-4">
              {[{ name: 'student_name', label: 'Full Name', type: 'text' }, { name: 'student_id', label: 'Student ID', type: 'text' }, { name: 'email', label: 'Email', type: 'email' }, { name: 'department', label: 'Branch', type: 'text' }].map(f => (
                <div key={f.name}>
                  <label className="block text-sm font-semibold text-text-main mb-2">{f.label}</label>
                  <input type={f.type} name={f.name} value={formData[f.name]} onChange={handleInputChange} required className={inputCls} />
                </div>
              ))}
              <div>
                <label className="block text-sm font-semibold text-text-main mb-2">Year</label>
                <select name="year" value={formData.year} onChange={handleInputChange} required className={`${inputCls} cursor-pointer`}>
                  <option value="">Select Year</option>
                  {years.filter(y => y.value !== 'All Years').map(y => <option key={y.value} value={y.value}>{y.label}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-text-main mb-2">Semester</label>
                <select name="semester" value={formData.semester} onChange={handleInputChange} required className={`${inputCls} cursor-pointer`}>
                  <option value="">Select Semester</option>
                  {semesters.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
              </div>
            </div>
            <div className="flex gap-3 justify-end mt-6 pt-6 border-t border-purple-glow-15">
              <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg border border-purple-glow-20 text-text-main hover:bg-primary bg-purple-glow-5 cursor-pointer">Cancel</button>
              <button type="submit" disabled={isSubmitting} className="px-6 py-2 rounded-lg text-btn-text font-semibold bg-primary shadow-glow-btn transition-all cursor-pointer disabled:opacity-50">
                {isSubmitting ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default EditStudentModal;